export const STAMP_TOOL_ID = "stamp";

const drawStamp = ({ ctx, point, text, penColor, penSize }) => {
  const lines = String(text || "")
    .split("\n")
    .filter(Boolean);
  if (!lines.length) {
    return;
  }

  const titleSize = Math.max(12, penSize * 2 + 8);
  const subSize = Math.max(10, titleSize - 3);
  const lineGap = 4;
  const paddingX = 10;
  const paddingY = 8;

  ctx.save();
  ctx.textBaseline = "top";

  const widths = lines.map((line, idx) => {
    ctx.font = `700 ${idx === 0 ? titleSize : subSize}px Arial`;
    return Math.ceil(ctx.measureText(line).width);
  });

  const maxWidth = Math.max(...widths);
  const contentHeight =
    titleSize +
    (lines.length - 1) * (subSize + lineGap) +
    (lines.length > 1 ? lineGap : 0);

  const boxWidth = maxWidth + paddingX * 2;
  const boxHeight = contentHeight + paddingY * 2;
  const left = point.x;
  const top = point.y;

  ctx.fillStyle = "rgba(255,255,255,0.95)";
  ctx.strokeStyle = penColor;
  ctx.lineWidth = Math.max(1.5, penSize * 0.5);
  ctx.beginPath();
  ctx.rect(left, top, boxWidth, boxHeight);
  ctx.fill();
  ctx.stroke();

  let y = top + paddingY;
  lines.forEach((line, idx) => {
    const size = idx === 0 ? titleSize : subSize;
    const weight = idx === 0 ? 700 : 500;
    ctx.font = `${weight} ${size}px Arial`;
    ctx.fillStyle = idx === 0 ? penColor : "#333";
    ctx.fillText(line, left + paddingX, y);
    y += size + lineGap;
  });

  ctx.restore();
};

export const stampToolConfig = {
  id: STAMP_TOOL_ID,
  usesPreview: false,
  cursor: "copy",
  onStart: () => true,
  onMove: () => {},
  onEnd: ({ ctx, endPoint, getStampText, penColor, penSize }) => {
    drawStamp({
      ctx,
      point: endPoint,
      text: getStampText?.(),
      penColor,
      penSize,
    });
  },
};

const StampToolButton = ({
  activeTool,
  stampPreset,
  onTogglePresets,
  isOpen = false,
  buttonRef,
}) => {
  return (
    <button
      ref={buttonRef}
      type="button"
      className={`btn ${
        activeTool === STAMP_TOOL_ID || isOpen ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={onTogglePresets}
      title={`Stamp presets (${stampPreset})`}
      aria-label={`Stamp (${stampPreset})`}
      aria-expanded={isOpen}
    >
      🏷
    </button>
  );
};

export default StampToolButton;
